import type { SystemPropertyUpdate } from '../systemEditSchema'
import { handleIsBatteryDcConnected } from './isBatteryDcConnected'
import { handleTimezoneOffset } from './timezoneOffset'

export const PROPERTY_HANDLERS: Record<string, (system: any, operation: SystemPropertyUpdate) => void> = {
  is_battery_dc_connected: handleIsBatteryDcConnected,
  timezoneOffset: handleTimezoneOffset,
}

export function hasCustomHandler(property: string): boolean {
  return property in PROPERTY_HANDLERS
}

export function executeCustomHandler(system: any, operation: SystemPropertyUpdate): void {
  const handler = PROPERTY_HANDLERS[operation.property]
  if (handler) {
    handler(system, operation)
  }
}
